import { Spin } from 'antd';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { AUTH_ENABLED } from './authConfig';

const RequireAuth = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (!AUTH_ENABLED) return children;

  if (loading) {
    return (
      <div style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Spin />
      </div>
    );
  }

  if (!user) {
    const returnTo = `${location.pathname}${location.search || ''}`;
    return (
      <Navigate
        to={`/login?return_to=${encodeURIComponent(returnTo)}`}
        replace
      />
    );
  }

  return children;
};

export default RequireAuth;
